import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { AsociacionFirmaSimpleComponent } from './asociacion-firma-simple.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [AsociacionFirmaSimpleComponent],
  imports: [
    SharedModule,
    CommonModule,
  ],
  exports: [
    AsociacionFirmaSimpleComponent // Exporta el componente para que otros módulos puedan usarlo
  ]
})
export class AsociacionFirmaSimpleModule { }
